import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

import useStyles from './useStyles';

// Field shell: leading icon, value, chevron. With `onClick` - acts as button;
// a `<select>` child is laid over the field as a transparent native control.
const PickerField = forwardRef(
  ({ icon, open, error, disabled, onClick, className, children }, ref) => {
    const classes = useStyles();
    const Chevron = open ? ExpandLessIcon : ExpandMoreIcon;

    const onKeyDown = (e) => {
      if (e.key !== 'Enter' && e.key !== ' ') return;
      e.preventDefault();
      onClick(e);
    };

    return (
      <div
        ref={ref}
        className={classnames(
          classes.root,
          open && classes.open,
          error && classes.error,
          disabled && classes.disabled,
          className
        )}
        {...(onClick && !disabled && { role: 'button', tabIndex: 0, onClick, onKeyDown })}
      >
        {icon && <span className={classes.icon}>{icon}</span>}
        <span className={classes.value}>{children}</span>
        <Chevron className={classes.chevron} />
      </div>
    );
  }
);

PickerField.propTypes = {
  icon: PropTypes.node,
  open: PropTypes.bool,
  error: PropTypes.bool,
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
  className: PropTypes.string,
  children: PropTypes.node,
};

PickerField.defaultProps = {
  icon: undefined,
  open: false,
  error: false,
  disabled: false,
  onClick: undefined,
  className: undefined,
  children: undefined,
};

export default PickerField;
